import { useMemo } from 'react';
import { DeliveryPublicColiInfoDataModel } from 'src/features/DeliveryPublicColiInfo/delivery-public-colis-info.types';

type Props = {
  shipping: DeliveryPublicColiInfoDataModel | null;
};

export const useCanThisShippingCreateDeliveryRequest = ({ shipping }: Props) => {
  return useMemo(() => {
    if (!shipping) {
      return false;
    }

    if (shipping.colis.every((coli) => coli.status === 'CANCELLED')) {
      return false;
    }

    if (shipping.colis.filter((coli) => coli.status !== 'CANCELLED').every((coli) => coli.status === 'WITHDRAWN')) {
      return false;
    }

    if (!shipping.toAgency?.city?.country?.code) {
      return false;
    }

    if (!shipping.enabledClientDeliveryRequests) {
      return false;
    }

    return true;
  }, [shipping]);
};
